"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectValue = void 0;
var tslib_1 = require("tslib");
var is_callable_1 = require("./is-callable");
/**
 * 处理 `R | (...args) => R` 类似类型
 * （ts <= 3.2 时无法依赖 typeof x === "function" 自动推导）
 */
function injectValue(target) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return ((0, is_callable_1.isCallable)(target) ? target.apply(void 0, (0, tslib_1.__spreadArray)([], (0, tslib_1.__read)(args), false)) : target);
    };
}
exports.injectValue = injectValue;
